
<!--TODO:
  1. add /absolute/_dropId and add <script src='https://cdn.8thwall.com/web/coaching-overlay/coaching-overlay.js'></script> to head
  2. create DropAbsolute
  3. create  MainAbsolute
  4. replace Main with MainAbsolute
  5. In MainAbsolute add
  <a-scene
  coaching-overlay="
    animationColor: #E86FFF;
    promptText: To generate scale push your phone forward and then pull back;"
  xrextras-loading
  xrextras-gesture-detector
  ...
  xrweb="scale: absolute;">
-->

<template>
  <Drop
    v-if="AFrameLoaded && XR8Loaded && XRExtrasLoaded"
    :base-url="baseUrl"
  />
  <div v-else class="flex flex-col items-center justify-center min-h-[80vh] text-center px-4">
    <img src="/dropsIcon_sm.png" alt="Drops" class="h-12 w-12 mb-6 opacity-60">
    <div class="w-10 h-10 border-4 border-gray-700 border-t-blue-500 rounded-full animate-spin mb-5" />
    <p class="text-gray-500 text-sm tracking-wide">
      Loading drop...
    </p>
  </div>
</template>

<script>
import Drop from '~/components/Drop.vue'
import eighthWall from '~/plugins/8thwall.js' // only import if wee're using 8thwall
import gtag from '~/plugins/gtagGA4.js'

export default {
  layout: 'ar',
  components: {
    Drop
  },
  data () {
    return {
      dropId: this.$route.params.dropId,
      AFrameLoaded: false,
      XR8Loaded: false,
      XRExtrasLoaded: false
      // coachingOverlayLoaded: false
    }
  },
  asyncData ({ req, res }) {
    return {
      baseUrl:
        'https://' +
        (process.server ? req.headers.host : window.location.hostname)
    }
  },
  async mounted () {
    if (this.$auth.user) {
      this.$store.commit('user', this.$auth.user)
      await this.$store.commit('authToken', this.$auth.user.token)
    }
    gtag() // google analytics
    await eighthWall()
    const onxrloaded = () => {
      // XR8 api calls go here
      this.XR8Loaded = true
    }
    // make sure 8w library is loaded first
    window.XR8 ? onxrloaded() : window.addEventListener('xrloaded', onxrloaded)
  },
  head () {
    return {
      script: [
        // {
        //   hid: 'coachingOverlay',
        //   src: 'https://cdn.8thwall.com/web/coaching-overlay/coaching-overlay.js',
        //   defer: true,
        //   callback: () => {
        //     this.coachingOverlayLoaded = true
        //   }
        // },
        {
          hid: '8Frame',
          src: 'https://cdn.8thwall.com/web/aframe/8frame-1.4.1.min.js',
          defer: true,
          callback: () => {
            this.AFrameLoaded = true
          }
        },
        {
          hid: 'AFrameExtras',
          src:
            'https://cdn.jsdelivr.net/gh/donmccurdy/aframe-extras@v6.1.1/dist/aframe-extras.min.js',
          defer: true
        },
        {
          hid: 'XRExtras',
          src: 'https://cdn.8thwall.com/web/xrextras/xrextras.js',
          defer: true,
          callback: () => {
            this.XRExtrasLoaded = true
          }
        }
      ],
      link: [
        {
          rel: 'stylesheet',
          href: 'https://api.mapbox.com/mapbox-gl-js/v3.4.0mapbox-gl.css'
        }
      ],
      meta: [
        {
          hid: 'og:title',
          property: 'og:title',
          content: 'Drops'
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: 'Scan the QR code to check out this AR experience'
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: `https://wox-drops.s3.amazonaws.com/img/qr/${this.dropId}.png`
        },
        { property: 'og:image:width', content: '400' },
        { property: 'og:image:height', content: '400' }
      ]
    }
  }
}
</script>
